<div class="content mt-3">
    <div class="row">
        <div class="col-lg-12">
            <div class="card">
                <div class="card-header cardheader">
                    <div class="col-12">
                        <h1 class="heading">App Wallet Setting</h1>
                    </div>
                </div>
                <form [formGroup]="settingForm" (submit)="updateSetting()">
                    <div class="card-body">
                        <div class="container-fluid">
                            <div class="row">
                                <div class="col-md-6 col-lg-6">
                                    <div class="form-group">
                                        <label class="form-label">Key Text*</label>
                                        <input type="text" formControlName="key_text1" disabled class="form-control" />
                                    </div>
                                </div>
                                <div class="col-md-6 col-lg-6">
                                    <div class="form-group">
                                        <label class="form-label">Key Value</label>
                                        <input type="text" formControlName="key_value1" class="form-control" />
                                    </div>
                                </div>
                                <div class="col-md-6 col-lg-6">
                                    <div class="form-group">
                                        <label class="form-label">Key Text*</label>
                                        <input type="text" formControlName="key_text2" disabled class="form-control" />
                                    </div>
                                </div>
                                <div class="col-md-6 col-lg-6">
                                    <div class="form-group">
                                        <label class="form-label">Key Value</label>
                                        <input type="text" formControlName="key_value2" class="form-control" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-footer">
                        <button type="submit" [disabled]="loading" class="btn btn-primary"><i *ngIf="loading"
                                class="fa fa-spin fa-spinner"></i>
                            <span>Update</span>
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>